import React from 'react'
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, makeStyles, Typography } from '@material-ui/core'
import CloseIcon  from '@material-ui/icons/CloseRounded'
import LoadingImage from '../../shared/components/LoadingImage'

const useStyle =makeStyles(()=>({
    title: {
        flexGrow: 1,
    }
}))

const ShippingItemDetails = ({onClose, title, Item}) => {
    const {ProductName, ProductBarcode, InternalId, ProductImageUrl, Price, Quantity} = Item;
    const classes = useStyle()

    return (
        <Dialog maxWidth="lg" open onClose={onClose} >
            <Grid container>
                <DialogTitle className={classes.title}>
                    {title}
                </DialogTitle>

                <IconButton size="small" style={{height:40, width:40, margin:10}} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Grid>

            <DialogContent>
                <Grid container spacing={2}>
                   <Grid item >
                      <LoadingImage url={ProductImageUrl} alt={ProductName} height={300} width={300} />
                   </Grid>
                   <Grid item>
                        <Typography> Nom : {ProductName} </Typography>
                        <Typography> Code Barre : {ProductBarcode} </Typography>
                        <Typography> Prosoft Id : {InternalId} </Typography>
                        <Typography> Prix d'achat : ${Price} </Typography>
                        <Typography> Quantité : {Quantity} </Typography>
                   </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default ShippingItemDetails
